import { sortBy } from 'lodash';
import moment from 'moment';
import { ISO_DATE_FORMAT, SERVICE_PORTAL } from '../../common/constants';
import { setDateToPay, setStatementDateToPay } from './payPlanReducer';

const updateACHAndNotDirectPaymentSource = (
  instrumentToPayWith,
  paymentServiceAccountId,
  isStatementAccount,
) => {
  let PaymentSource = {
    achBankAccountNumber: instrumentToPayWith.achBankAccountNumber,
    achBankAccountTypeCd: instrumentToPayWith.achBankAccountTypeCd,
    achName: instrumentToPayWith.achName,
    achRoutingNumber: instrumentToPayWith.achRoutingNumber,
    achBankName: instrumentToPayWith.achBankName,
    achStandardEntryClassCd: instrumentToPayWith.achStandardEntryClassCd,
    sourceTypeCd: 'InstallmentSource',
    customerPaymentProfileId: instrumentToPayWith?.id ? instrumentToPayWith.id.toString() : '',
    methodCd: instrumentToPayWith
      ? instrumentToPayWith.sourceType
        ? instrumentToPayWith.sourceType
        : instrumentToPayWith.methodCd
        ? instrumentToPayWith.methodCd
        : ''
      : '',
    sourceName: SERVICE_PORTAL,
    paymentServiceAccountId,
  };
  if (isStatementAccount) {
    return { electronicPaymentSources: [PaymentSource] };
  }
  return { electronicPaymentSource: PaymentSource };
};
const updateCCAndNotDirectPaymentSource = (
  instrumentToPayWith,
  customerId,
  paymentServiceAccountId,
  isStatementAccount,
) => {
  let PaymentSource = {
    methodCd: instrumentToPayWith
      ? instrumentToPayWith.sourceType
        ? 'Credit Card'
        : instrumentToPayWith.methodCd
        ? instrumentToPayWith.methodCd
        : ''
      : '',
    customerPaymentProfileId: instrumentToPayWith
      ? instrumentToPayWith.customerPaymentProfileId
        ? instrumentToPayWith.customerPaymentProfileId
        : instrumentToPayWith?.id?.toString()
        ? instrumentToPayWith?.id?.toString()
        : ''
      : '',
    customerProfileId: `CUST-${customerId}`,
    creditCardNumber: instrumentToPayWith?.lastFour
      ? instrumentToPayWith.lastFour
      : instrumentToPayWith.creditCardNumber
      ? instrumentToPayWith.creditCardNumber
      : '',
    creditCardTypeCd: instrumentToPayWith?.cardType
      ? instrumentToPayWith.cardType
      : instrumentToPayWith.creditCardTypeCd
      ? instrumentToPayWith.creditCardTypeCd
      : '',
    sourceTypeCd: 'InstallmentSource',
    sourceName: SERVICE_PORTAL,
    paymentServiceAccountId,
  };
  if (isStatementAccount) {
    return { electronicPaymentSources: [PaymentSource] };
  }
  return { electronicPaymentSource: PaymentSource };
};
export const updatePayPlanBody = (
  instrumentToPayWith,
  newPlan,
  payPlanDateToPay,
  customerId,
  paymentServiceAccountId,
  revision,
  isStatementAccount,
) => {
  let requestPayload;
  let PaymentSource;
  if (
    (instrumentToPayWith?.methodCd === 'ACH' || instrumentToPayWith?.sourceType === 'ACH') &&
    (isStatementAccount
      ? newPlan.payPlanCd.includes('Automated')
      : !newPlan.payPlan.payPlanTypeCd.includes('None'))
  ) {
    PaymentSource = updateACHAndNotDirectPaymentSource(
      instrumentToPayWith,
      paymentServiceAccountId,
      isStatementAccount,
    );
  } else if (
    isStatementAccount
      ? newPlan.payPlanCd.includes('Automated')
      : !newPlan.payPlan.payPlanTypeCd.includes('None')
  ) {
    PaymentSource = updateCCAndNotDirectPaymentSource(
      instrumentToPayWith,
      customerId,
      paymentServiceAccountId,
      isStatementAccount,
    );
  } else {
    PaymentSource = {};
  }
  requestPayload = {
    _revision: revision,
    payPlanCd: newPlan.payPlanCd,
    ...(payPlanDateToPay &&
      newPlan?.payPlan?.dayOfMonthInd !== 'No' && {
        paymentDay: payPlanDateToPay ? payPlanDateToPay.toString() : '',
      }),
    ...PaymentSource,
  };
  return requestPayload;
};
export const updatePayMethodBody = (
  instrumentToPayWith,
  account,
  customerId,
  paymentServiceAccountId,
  revision,
  isStatementAccount,
) => {
  let requestPayload;
  let PaymentSource;
  if (isStatementAccount) {
    if (
      (instrumentToPayWith?.methodCd === 'ACH' || instrumentToPayWith?.sourceType === 'ACH') &&
      !account?.fullAccount?.underlyingBillingAccounts[0]?.payPlan?.payPlanTypeCd?.includes('None')
    ) {
      PaymentSource = updateACHAndNotDirectPaymentSource(
        instrumentToPayWith,
        paymentServiceAccountId,
        isStatementAccount,
      );
    } else if (
      !account?.fullAccount?.underlyingBillingAccounts[0]?.payPlan?.payPlanTypeCd?.includes('None')
    ) {
      PaymentSource = updateCCAndNotDirectPaymentSource(
        instrumentToPayWith,
        customerId,
        paymentServiceAccountId,
        isStatementAccount,
      );
    } else {
      PaymentSource = {};
    }
  } else {
    if (
      (instrumentToPayWith?.methodCd === 'ACH' || instrumentToPayWith?.sourceType === 'ACH') &&
      !account?.payPlan?.payPlanTypeCd.includes('None')
    ) {
      PaymentSource = updateACHAndNotDirectPaymentSource(
        instrumentToPayWith,
        paymentServiceAccountId,
        isStatementAccount,
      );
    } else if (!account?.payPlan?.payPlanTypeCd?.includes('None')) {
      PaymentSource = updateCCAndNotDirectPaymentSource(
        instrumentToPayWith,
        customerId,
        paymentServiceAccountId,
        isStatementAccount,
      );
    } else {
      PaymentSource = {};
    }
  }

  requestPayload = {
    _revision: revision,
    ...(account.arPolicy?.paymentDay && {
      paymentDay: account.arPolicy?.paymentDay ? account.arPolicy?.paymentDay.toString() : '',
    }),
    ...PaymentSource,
  };
  if (!isStatementAccount) {
    requestPayload.payPlanCd = account.payPlan.payPlanCd;
  }
  return requestPayload;
};

export const handlePayDateChange = (dayToPay, dispatch) => {
  let checkDate = dayToPay;
  if (checkDate > 31) {
    checkDate = 1;
  }
  dispatch(setDateToPay(Math.abs(checkDate)));
};
export const handleStatementPayDateChange = (dayToPay, dispatch) => {
  dispatch(setStatementDateToPay(dayToPay));
};
export const collapseEventBody = {
  category: 'show-payment-schedule-button',
  action: 'click',
  label: 'collapse',
};

export const expandEventBody = {
  category: 'show-payment-schedule-button',
  action: 'click',
  label: 'expand',
};
export const setStatementAccountsAndMerge = (
  fullAccount,
  paymentTypesMap,
  isScheduledOrPending,
) => {
  let billingHistory = [];

  if (fullAccount.billingHistory) {
    billingHistory = fullAccount.billingHistory
      .filter((bill) => paymentTypesMap.has(bill.typeCd))
      .map((topLevelBill) => {
        const enrichedBill = {
          ...topLevelBill,
          receiptDt: topLevelBill.receiptDt,
          receiptAmt: topLevelBill.receiptAmt,
          receiptReference: topLevelBill.receiptReference,
          transactionAmount: topLevelBill.receiptAmt,
        };

        if (fullAccount.underlyingBillingAccounts && topLevelBill.receiptReference) {
          const matchingUnderlyingData = fullAccount.underlyingBillingAccounts
            .filter((account) => account.billingHistory)
            .flatMap((account) =>
              account.billingHistory.filter(
                (history) => history.receiptReference === topLevelBill.receiptReference,
              ),
            );

          if (matchingUnderlyingData.length > 0) {
            const underlyingMatch = matchingUnderlyingData[0];
            Object.assign(enrichedBill, {
              ...underlyingMatch,
              // Preserve top-level values
              receiptDt: topLevelBill.receiptDt,
              receiptAmt: topLevelBill.receiptAmt,
              receiptReference: topLevelBill.receiptReference,
              transactionAmount: topLevelBill.receiptAmt,
            });
          }
        }

        return enrichedBill;
      });
  }

  // Still get pendingReceipts if needed for scheduled/pending payments
  let underlyingBillingAccounts = [];
  if (fullAccount.underlyingBillingAccounts) {
    underlyingBillingAccounts = fullAccount.underlyingBillingAccounts.flatMap((receipt) => {
      if (receipt.pendingReceipts) {
        return receipt.pendingReceipts.filter((receipt) => receipt.receiptAmt !== '0.00');
      }
      return [];
    });
    underlyingBillingAccounts = underlyingBillingAccounts.filter((array) => array !== undefined);
  }

  let merged = [].concat(billingHistory, underlyingBillingAccounts);

  merged = sortBy(merged, (receipt) => moment(receipt.receiptDt, ISO_DATE_FORMAT).valueOf());
  merged = merged.reverse();

  if (isScheduledOrPending) {
    merged = merged.filter((item) => !paymentTypesMap.has(item.typeCd));
  } else {
    merged = merged.filter((item) => paymentTypesMap.has(item.typeCd));
  }

  return merged;
};
export const setPolicyAccountsAndMerge = (fullAccount, paymentTypesMap, isScheduledOrPending) => {
  let billingHistory = [];
  let pendingReceipts = [];
  if (fullAccount.billingHistory) {
    billingHistory = fullAccount.billingHistory.filter((bill) => paymentTypesMap.has(bill.typeCd));
  }
  if (fullAccount.pendingReceipts) {
    pendingReceipts = fullAccount.pendingReceipts.filter(
      (receipt) => receipt.receiptAmt !== '0.00',
    );
  }

  let merged = [].concat(billingHistory, pendingReceipts);
  merged = sortBy(merged, (receipt) => moment(receipt.receiptDt, ISO_DATE_FORMAT).valueOf());
  merged = merged.reverse();
  if (isScheduledOrPending) {
    merged = merged.filter((item) => !paymentTypesMap.has(item.typeCd));
  } else {
    merged = merged.filter((item) => paymentTypesMap.has(item.typeCd));
  }

  return merged;
};
export const checkSaveDisabled = (
  accountId,
  showEditPaymentSchedule,
  newPlan,
  instrumentToPayWith,
  payPlanDateToPay,
  showEditPaymentMethod,
  isLoading,
) => {
  if (isLoading) {
    return false;
  }
  if (showEditPaymentSchedule[accountId] === true) {
    if (
      newPlan &&
      newPlan.payPlan.payPlanTypeCd.includes('None') &&
      (newPlan.payPlan.dayOfMonthInd === 'Optional' || newPlan.payPlan.dayOfMonthInd === 'No')
    ) {
      //direct pay plan and optional or no for payplan - this means by having a new plan you can go ahead
      return true;
    }
    if (
      newPlan &&
      newPlan.payPlan.dayOfMonthInd === 'Required' &&
      newPlan.payPlan.payPlanTypeCd.includes('None')
    ) {
      //direct pay plan and required, make sure new plan and day to pay
      return newPlan && payPlanDateToPay;
    }
    if (
      newPlan &&
      (newPlan.payPlan.dayOfMonthInd === 'No' || newPlan.payPlan.dayOfMonthInd === 'Optional')
    ) {
      // dayof month not required, and not a direct so instrument required
      return newPlan && instrumentToPayWith;
    }
    // couldn't account for additional scenario, check for everything
    return newPlan && payPlanDateToPay && payPlanDateToPay !== 0 && instrumentToPayWith;
  }
  if (showEditPaymentMethod[accountId] === true) {
    return instrumentToPayWith;
  }
};
export const checkSaveDisabledStatementAccount = (
  newPlan,
  instrumentToPayWith,
  payPlanDateToPay,
  isLoading,
  showEditPaymentMethod,
  accountId,
) => {
  if (isLoading) {
    return false;
  }
  if (showEditPaymentMethod[accountId] === true) {
    return instrumentToPayWith;
  }
  return (
    newPlan &&
    payPlanDateToPay &&
    (newPlan.payPlanCd.includes('Automated') ? instrumentToPayWith : true)
  );
};
export const checkSaveDisabledUnderlying = (
  accountId,
  showEditPaymentSchedule,
  newPlan,
  instrumentToPayWith,
  payPlanDateToPay,
  showEditPaymentMethod,
  isLoading,
) => {
  if (isLoading) {
    return false;
  }
  if (showEditPaymentSchedule[accountId] === true) {
    if (
      newPlan &&
      newPlan.payPlan.payPlanTypeCd.includes('None') &&
      (newPlan.payPlan.dayOfMonthInd === 'Optional' || newPlan.payPlan.dayOfMonthInd === 'No')
    ) {
      //direct pay plan and optional or no for payplan - this means by having a new plan you can go ahead
      return true;
    }
    if (
      newPlan &&
      newPlan.payPlan.dayOfMonthInd === 'Required' &&
      newPlan.payPlan.payPlanTypeCd.includes('None')
    ) {
      //direct pay plan and required, make sure new plan and day to pay
      return newPlan && payPlanDateToPay;
    }
    if (
      newPlan &&
      (newPlan.payPlan.dayOfMonthInd === 'No' || newPlan.payPlan.dayOfMonthInd === 'Optional')
    ) {
      // day of month not required, and not a direct so instrument required
      return newPlan && instrumentToPayWith;
    }
    // couldn't account for additional scenario, check for everything
    return newPlan && payPlanDateToPay && instrumentToPayWith;
  }
  if (showEditPaymentMethod[accountId] === true) {
    return instrumentToPayWith;
  }
};
export const checkEditable = (
  account,
  isUnderlyingPolicies,
  underlyingPoliciesPayPlansEditable,
  editPayPlan,
) => {
  if (isUnderlyingPolicies && !underlyingPoliciesPayPlansEditable) {
    return false;
  }
  if (isUnderlyingPolicies && underlyingPoliciesPayPlansEditable) {
    return true;
  }
  return !isUnderlyingPolicies && editPayPlan && parseFloat(account.totalAmt) > 0;
};